import { useState, useCallback } from 'react';

/**
 * Technician session state (localStorage-backed).
 * Persists across page refreshes but not cross-device.
 */

const SESSION_KEY = 'airtouch_tech_session';

function loadSession() {
  try {
    const saved = localStorage.getItem(SESSION_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
}

function saveSession(session) {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export default function useTechSession() {
  const [session, setSession] = useState(loadSession);

  const login = useCallback((technicianId, fullName, projectId, projectName, language) => {
    const s = {
      technicianId,
      fullName,
      projectId,
      projectName,
      language,
      workOrderId: null,
      loginTime: new Date().toISOString(),
    };
    setSession(s);
    saveSession(s);
  }, []);

  const setWorkOrder = useCallback((workOrderId) => {
    setSession(prev => {
      const updated = { ...prev, workOrderId };
      saveSession(updated);
      return updated;
    });
  }, []);

  const logout = useCallback(() => {
    setSession(null);
    localStorage.removeItem(SESSION_KEY);
  }, []);

  const isLoggedIn = !!session?.technicianId;

  return {
    session,
    isLoggedIn,
    login,
    setWorkOrder,
    logout,
  };
}
